import { endPoints } from '@/configs/endPoints'
import { API } from '@/utils/fetcher'

export async function getChatBot(): Promise<any> {
  const data = await API.get<any>(endPoints.chatbot)

  return data
}
